import {split, from, ApolloClient, InMemoryCache, ApolloLink} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {createUploadLink} from 'apollo-upload-client';
import {getMainDefinition} from '@apollo/client/utilities';
import {GraphQLWsLink} from '@apollo/client/link/subscriptions';
import {createClient} from 'graphql-ws';

//Constants
import {GRAPHQL_URL, GRAPHQL_WS_URL} from '~config/constants';
//Config
import {LOCAL_STORE_TOKEN} from '~config/localStore';
import typeDefs from '~graphql/apolloClientSideSchema/typeDefs';
import typePolicies from '~graphql/apolloClientSideSchema/typePolicies';
import {errorLink, retryLink} from './commonApolloLinks';
//Utils
import LStorage from '~utils/LStorage';
//Types
import {JwtType} from '~graphqlResources';



const isDev = process.env.NODE_ENV !== 'production';

const uploadLink = createUploadLink({
    uri: GRAPHQL_URL
}) as unknown as ApolloLink;

function getAuthHeader() {
    const jwtToken = LStorage.getParsedFromStorage<JwtType>(LOCAL_STORE_TOKEN);

    return ({
        Authorization: jwtToken?.token
            ? `Bearer ${jwtToken?.token}`
            : ''
    });
}

export const wsClient = createClient({
    url: GRAPHQL_WS_URL,
    connectionParams: () => {
        const authHeader = getAuthHeader();
        return {
            // Pass auth in connectionParams for WebSocket
            Authorization: authHeader.Authorization
        };
    },
    on: {
        // eslint-disable-next-line no-console
        connected: () => isDev && console.log('WebSocket connected'),
        // eslint-disable-next-line no-console
        closed: () => isDev && console.log('WebSocket closed'),
        // eslint-disable-next-line no-console
        error: (error) => isDev && console.error('WebSocket error:', error)
    }
});

const wsLink = new GraphQLWsLink(wsClient);

const authLink = setContext((_, {headers}) => {
    return {
        headers: {
            ...headers,
            ...getAuthHeader()
        }
    };
});

const httpChain = from([authLink, retryLink, uploadLink]);

const splitLink = split(
    ({query}) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    httpChain
);

const cache = new InMemoryCache({
    typePolicies
});

const client = new ApolloClient({
    link: from([errorLink, splitLink]),
    typeDefs,
    cache,
    devtools: {
        enabled: isDev
    }
});

export default client;
